import { IModel } from './model';
import { IAppInsatalledOnDevice } from './IApp-on-device.interface';
export interface IDevice {
  serialNumber: string;
  description: string;
  deviceUid: string;
  createdDate: Date;
  modifiedDate: Date;
  version: number;
  status: string;
  model: IModel;
  apps?: { entities: IAppInsatalledOnDevice[]; isLoading: boolean };
}
export interface IDevicesResponse {
  status: string;
  data?: IDevice[] | null;
  statusCodes?: null[] | null;
}
